module.exports = __webpack_public_path__ + "img/made_4.cc7b455c.png";